import axios from "axios";
import { setApiConfigFromUrl, triggerTimerForPincodeScreen} from "../helpers/utility";
import baseApiHelper from "../services/baseApiHelper";

export const axiosBaseQuery =
  () =>
  async ({ url, method, data, params }) => {
    try {
      
      const baseUrl  = setApiConfigFromUrl();
      const result = await axios({ url: baseUrl + url, method, data, params });
      triggerTimerForPincodeScreen();

      if (
        result?.data && 
        result?.data?.response && 
        result?.data?.response?.code!=0) {
        baseApiHelper().responseErrorCheck(result?.data?.response);
      }
      return  { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
};
